import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import Nav from "./Nav";

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currency: "USD",
    };
  }

  componentDidMount() {
    let id = this.props.auth.user.id;
    axios
      .get(`https://trend-backend.herokuapp.com/api/users/${id}/data`)
      .then((res) => {
        // axios.get(`http://localhost:3005/api/users/${id}/data`).then((res) => {
        var userData = res.data;
        delete userData["password"];
        this.setState({
          name: userData.name,
          email: userData.email,
          created: userData.date,
          id: userData._id,
          stocks: [userData.stocks],
          cryptos: [userData.cryptos],
        });
      });
  }

  render() {
    return (
      <main>
        <Nav />
        <div className="settings-page">
          <div className="settings-wrapper">
            <div className="top">
              <div className="title-wrapper">
                <h2 className="welcome-title">Account Info and Settings</h2>
              </div>
            </div>
            <div className="bottom">
              <div className="settings">
                <section className="top">
                  <div className="info">
                    <div className="setting-title-wrapper">
                      <h3 className="title">Stocks</h3>
                    </div>
                    <div className="items">
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                    </div>
                  </div>
                  <div className="info">
                    <div className="setting-title-wrapper">
                      <h3 className="title">Crypto</h3>
                    </div>
                    <div className="items">
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                      <div className="item">
                        <h4 className="symbol">TEST</h4>
                        <span className="amount"></span>
                      </div>
                    </div>
                  </div>
                </section>
                <section className="bottom">
                  <div className="account-settings">
                    <div className="left">
                      <div className="setting-title-wrapper">
                        <h3 className="title">Site Settings</h3>
                      </div>
                      <div className="settings">
                        <div className="setting">
                          <h3 className="setting-title">Dark mode</h3>
                          <button className="switch"></button>
                        </div>
                        <div className="setting">
                          <h3 className="setting-title">Placeholder</h3>
                          <button className="switch"></button>
                        </div>
                        <div className="setting">
                          <h3 className="setting-title">Placeholder</h3>
                          <button className="switch"></button>
                        </div>
                      </div>
                    </div>
                    <div className="right">
                      <div className="setting-title-wrapper">
                        <h3 className="title">Edit Account Info</h3>
                      </div>
                      <div className="settings">
                        <div className="setting">
                          <button className="btn">Edit name</button>
                        </div>
                        <div className="setting">
                          <button className="btn">Update email</button>
                        </div>
                        <div className="setting">
                          <button className="btn" type="button">
                            Change password
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

Account.propTypes = {
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, {})(Account);
